import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';

import { ReactComponent as FilesIcon } from '@/assets/icons/files-records.svg';
import { routeFileSelector } from '@/utilz/i18n';
import FooterContentCard from '@/views/screens/common/FooterContentCard';

const ShipmentFooter = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const footerCount = useSelector((state) => state.savers.shipmentList);
  return (
    <div>
      <Row justify="space-around" className=" footer-container background-header px-20  py-12">
        <Col>
          <FooterContentCard
            count={
              <NumericFormat
                thousandsGroupStyle="thousand"
                displayType="text"
                value={String(footerCount.totalPageCount)}
                thousandSeparator
              />
            }
            label={t('translation:shipment.footer.totalRecords')}
            Icon={FilesIcon}
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(ShipmentFooter);
